// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * The following are shared across all platforms and apps
 */
/**
 * The following are shared across all platforms and apps
 */
.heading-section {
  color: var(--undp-jtf-btn-dark-color);
  padding: 2rem 3rem 0 0;
  border-bottom: 2px solid #e8e8e8;
}
.heading-section .heading {
  font: normal normal bold 24px/32px "OpenSans-Regular";
}

.get-alerts-body-container {
  background-color: #fff;
  color: var(--undp-jtf-btn-dark-color);
  border-radius: 20px;
  padding: 4rem 3rem 4rem 3rem;
  font-family: "OpenSans-Regular";
  margin-bottom: 4rem;
}
.get-alerts-body-container .form-group {
  margin-top: 1rem;
}
.get-alerts-body-container .form-group label,
.get-alerts-body-container .form-group p {
  color: var(--undp-jtf-btn-dark-color);
  font-size: 16px;
  font-weight: 600;
}
.get-alerts-body-container .form-group .form-control {
  border: 1px solid #707070;
}
.get-alerts-body-container .form-group .error p {
  color: red;
  margin-top: 5px;
  font-weight: 500;
}
.get-alerts-body-container .form-group .drop-show {
  padding: 4px;
  width: 95%;
  background-color: #fff;
  border: 1px solid #bababa;
  position: absolute;
  z-index: 100;
  box-shadow: 0 6px 10px rgba(0, 0, 0, 0.15);
  margin-left: 1px;
}
.get-alerts-body-container .form-group .drop-show label {
  display: flex;
  font-size: 15px;
  cursor: pointer;
}
.get-alerts-body-container .form-group .drop-show label span {
  display: inline-block;
  padding-left: 5px;
}
.get-alerts-body-container .section {
  border-bottom: 2px solid #e8e8e8;
  padding-bottom: 2rem;
}
.get-alerts-body-container .section .map-section p {
  color: var(--undp-jtf-btn-dark-color);
  font-size: 16px;
  font-weight: 600;
}
.get-alerts-body-container .section .map-section .map-container {
  height: 80%;
  border-radius: 20px;
}
@media (max-width: 750px) {
  .get-alerts-body-container .section .map-section .map-container { /* Corrected selector */
    height: 240%; /* This will apply to screens with a width less than 540px */
    border-radius: 20px;
    margin-top: 10px;
  }
}
.get-alerts-body-container .field {
  margin-top: 3rem;
}
@media (max-width: 750px) {
  .get-alerts-body-container .field {
    margin-top: 5rem;
  }
  .get-alerts-body-container .field_mobile {
    margin-top: 1rem;
  }
}
.get-alerts-body-container .btn-lg-blue {
  color: #fff;
  background-color: var(--undp-jtf-btn-dark-color);
  padding-top: 10px;
  padding-bottom: 10px;
  border-radius: 10px;
}`, "",{"version":3,"sources":["webpack://./libs/scss/_index.scss","webpack://./apps/hybrid-app/src/app/features/get-alerts/get-alerts.component.scss","webpack://./apps/hybrid-app/src/scss/_variables.scss"],"names":[],"mappings":"AAAA;;EAAA;AAAA;;EAAA;ACEA;EACE,qCAAA;EACA,sBAAA;EACA,gCAAA;AAKF;AAJE;EACE,qDAAA;AAMJ;;AAHA;EACE,sBAAA;EACA,qCAAA;EACA,mBAAA;EACA,4BAAA;EACA,+BCVqB;EDWrB,mBAAA;AAMF;AALE;EACE,gBAAA;AAOJ;AANI;;EAEE,qCAAA;EACA,eAAA;EACA,gBAAA;AAQN;AANI;EACE,yBAAA;AAQN;AALM;EACE,UAAA;EACA,eAAA;EACA,gBAAA;AAOR;AAJI;EACE,YAAA;EACA,UAAA;EACA,sBAAA;EACA,yBAAA;EACA,kBAAA;EACA,YAAA;EAGA,0CAAA;EACA,gBAAA;AAMN;AALM;EACE,aAAA;EACA,eAAA;EACA,eAAA;AAOR;AANQ;EACE,qBAAA;EACA,iBAAA;AAQV;AAHE;EACE,gCAAA;EACA,oBAAA;AAKJ;AAHM;EACE,qCAAA;EACA,eAAA;EACA,gBAAA;AAKR;AAHM;EACE,WAAA;EACA,mBAAA;AAKR;AAFM;EACE,kEAAA,uBAAA;IACE,YAAA,EAAA,4DAAA;IACA,mBAAA;IACA,gBAAA;EAIR;AACF;AAAE;EACE,gBAAA;AAEJ;AAAE;EACE;IACE,gBAAA;EAEJ;EAAE;IACE,gBAAA;EAEJ;AACF;AAAE;EACE,WAAA;EACA,gDAAA;EACA,iBAAA;EACA,oBAAA;EACA,mBAAA;AAEJ","sourcesContent":["/**\n * The following are shared across all platforms and apps\n */\n\n// shared variables\n@import 'variables';\n\n// create/import other scss files or define as needed...\n","@import '@eview/scss/index';\n@import '../../../scss/variables';\n.heading-section {\n  color: var(--undp-jtf-btn-dark-color);\n  padding: 2rem 3rem 0 0;\n  border-bottom: 2px solid #e8e8e8;\n  .heading {\n    font: normal normal bold 24px/32px $primary-font-regular;\n  }\n}\n.get-alerts-body-container {\n  background-color: #fff;\n  color: var(--undp-jtf-btn-dark-color);\n  border-radius: 20px;\n  padding: 4rem 3rem 4rem 3rem;\n  font-family: $primary-font-regular;\n  margin-bottom: 4rem;\n  .form-group {\n    margin-top: 1rem;\n    label,\n    p {\n      color: var(--undp-jtf-btn-dark-color);\n      font-size: 16px;\n      font-weight: 600;\n    }\n    .form-control {\n      border: 1px solid #707070;\n    }\n    .error {\n      p {\n        color: red;\n        margin-top: 5px;\n        font-weight: 500;\n      }\n    }\n    .drop-show {\n      padding: 4px;\n      width: 95%;\n      background-color: #fff;\n      border: 1px solid #bababa;\n      position: absolute;\n      z-index: 100;\n      -webkit-box-shadow: 0 6px 10px rgba(0, 0, 0, 0.15);\n      -moz-box-shadow: 0 6px 10px rgba(0, 0, 0, 0.15);\n      box-shadow: 0 6px 10px rgba(0, 0, 0, 0.15);\n      margin-left: 1px;\n      label {\n        display: flex;\n        font-size: 15px;\n        cursor: pointer;\n        span {\n          display: inline-block;\n          padding-left: 5px;\n        }\n      }\n    }\n  }\n  .section {\n    border-bottom: 2px solid #e8e8e8;\n    padding-bottom: 2rem;\n    .map-section {\n      p {\n        color: var(--undp-jtf-btn-dark-color);\n        font-size: 16px;\n        font-weight: 600;\n      }\n      .map-container {\n        height: 80%;\n        border-radius: 20px;\n      }\n\n      @media (max-width: 750px) {\n        .map-container { /* Corrected selector */\n          height: 240%; /* This will apply to screens with a width less than 540px */\n          border-radius: 20px;\n          margin-top: 10px;\n      }\n     }\n    }\n  }\n  .field {\n    margin-top: 3rem;\n  }\n  @media (max-width: 750px) {\n    .field {\n      margin-top: 5rem;\n    }\n    .field_mobile {\n      margin-top: 1rem;\n    }\n }\n  .btn-lg-blue {\n    color: #fff;\n    background-color: var(--undp-jtf-btn-dark-color);\n    padding-top: 10px;\n    padding-bottom: 10px;\n    border-radius: 10px;\n  }\n}\n","@import '@eview/scss/index';\n\n$primary-font: \"Montserrat\";\n$primary-font-bold: \"OpenSans-Bold\";\n$primary-font-medium: \"OpenSans-Light\";\n$primary-font-regular: \"OpenSans-Regular\";\n$primary-font-light: \"OpenSans-Light\";\n$primary-font-thin: \"OpenSans-Thin\";\n$secondary-font : \"Lato\";\n$secondary-font-bold: \"OpenSans-Bold\";\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
